import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ViewChildren,
  QueryList
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import _ from 'lodash';
import { SelectItem } from 'primeng/api';
import { MultiSelect } from 'primeng/multiselect';
import { Table } from 'primeng/table';
import { Subscription, Observable } from 'rxjs';
import {
  ProgramTypesGUID,
  EventDocumentTypeIds
} from '../../../models/_enum-collections';
import { CustomerPreviewInput } from '../../../models/customer-validation-preview-input.model';
import { EventRegistrationModel } from '../../../models/event-registration.model';
import { EventSearchFilterRequest } from '../../../models/event-search-filter-request.model';
import { PagedResult } from '../../../models/page-result.model';
import { AppConstants } from '../../common/app-constants';
import { EditEventComponent } from '../../mcap-events/components/edit-event/edit-event.component';
import { LocalStorageService } from '../../services/local-storage-service';
import { OsmosisEditService } from '../../services/osmosis-edit.service';
import { CommonSharedModule } from '../../common/shared.module';
import { CustomerSurveyPreviewComponent } from '../../mcap-events/preview/customer-survey-preview/customer-survey-preview.component';
import { EventDashboardService } from '../../services/event-dashboard.service';

@Component({
  selector: 'app-customer-surveys',
  templateUrl: './customer-surveys.component.html',
  styleUrls: ['./customer-surveys.component.scss'],
  standalone: true,
  imports: [
    CommonSharedModule,
    EditEventComponent,
    CustomerSurveyPreviewComponent
  ]
})
export class CustomerSurveysComponent implements OnInit {
  @Input() loading!: boolean;
  dataViewRecsPerPage!: number;
  pageLinksPerPage!: number;
  totalRecords!: number;
  tblPageNumber = 1;
  display!: boolean;
  scrollableCols = new Array<any>();
  eventsDisplayed!: EventRegistrationModel[];
  l1InternalStatusDropdownItems: SelectItem[] = [];
  l2InternalStatusDropdownItems: SelectItem[] = [];
  eventSearchFilterRequest!: EventSearchFilterRequest;
  eventSearchSubscription!: Subscription;
  @ViewChild('dt', { static: false }) dt!: Table;
  @ViewChildren('tak') components!: QueryList<MultiSelect>;
  @ViewChild('editNavChild', { static: false })
  editNavChild!: EditEventComponent;
  editNav = false;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  delayedLoadSearchContent!: Function;
  loadingIcon = 'fa-circle-o-notch';
  customerSurveyPreviewInput!: CustomerPreviewInput;
  canShowCustomerSurveyPreviewModel!: boolean;
  allEventsDisplayed!: EventRegistrationModel[];
  loadEditComponent!: boolean;
  eventIdPassToChild!: number;
  eventEditInput!: EventRegistrationModel;
  mrppProgram: string = ProgramTypesGUID.MRPP;
  showFullScreen!: boolean;

  constructor(
    private _eventDashboardServices: EventDashboardService,
    private localStorage: LocalStorageService,
    private osmService: OsmosisEditService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.dataViewRecsPerPage = AppConstants.dataListRecsPerPage;
    this.pageLinksPerPage = AppConstants.dataListPagerLinks;
    this.delayedLoadSearchContent = _.debounce(this.loadEvents, 1000);
    this.eventSearchFilterRequest = {
      pageSize: this.dataViewRecsPerPage,
      page: this.tblPageNumber,
      programTypeGuid: ProgramTypesGUID.MRPP
    };
    this.loadEvents();
    this.localStorage.setFullscreenMode(true);
    this.showFullScreen = this.localStorage.getFullscreenMode();
    this.scrollableCols = [
      { field: 'eventKey', header: 'Engagement Id' },
      { field: 'partnerOrgName', header: 'Partner Org' },
      { field: 'customerOrgName', header: 'Customer Org' },
      { field: 'customerCountry', header: 'Customer Country' },
      { field: 'fiscalYear', header: 'Fiscal Year' },
      { field: 'l1InternalStatus', header: 'L1 Internal Status' },
      { field: 'l2InternalStatus', header: 'L2 Internal Status' },
      { field: 'submittedDate', header: 'Uploaded Date' }
    ];
  }

  loadEvents(): void {
    this.loading = true;
    this.eventSearchSubscription = this._eventDashboardServices
      .getAwaitingCustomerSurveyReviewMrpp(this.eventSearchFilterRequest)
      .subscribe(data => {
        this.eventsDisplayed = data.results;
        this.totalRecords = data.rowCount;
        this.loading = false;
      });
  }

  getL1InternalStatusList() {
    this.osmService.getL1InternalStatusDropDown().subscribe(PTList => {
      for (const item of PTList) {
        const fl1InternalStatusDrpdwn: SelectItem = {
          label: item.l1internalStatus,
          value: item.l1internalStatus
        };
        this.l1InternalStatusDropdownItems.push(fl1InternalStatusDrpdwn);
      }
    });
  }

  getL2InternalStatusList() {
    this.osmService.getL2InternalStatusDropDown().subscribe(PTList => {
      for (const item of PTList) {
        const fl1InternalStatusDrpdwn: SelectItem = {
          label: item.l2internalStatus,
          value: item.l2internalStatus
        };
        this.l2InternalStatusDropdownItems.push(fl1InternalStatusDrpdwn);
      }
    });
  }

  pageChange(e) {
    const calc = e.first / this.dataViewRecsPerPage + 1;

    this.tblPageNumber = calc;
    this.eventSearchFilterRequest.page = this.tblPageNumber;
  }

  applyFilter(event) {
    this.totalRecords = event.filteredValue.length;
    this.pageChange({ first: 0 });
  }

  onSearchInput(event, dt) {
    if (!event.target.value || event.target.value.trim() !== '') {
      dt.filterGlobal(event.target.value, 'contains');
    }
  }

  reset() {
    this.components['_results'].forEach(ds => {
      ds.value = null;
    });

    if (this.dt) {
      this.dt.filter('', 'taskOwner', 'in');
      this.dt.filter('', 'l1InternalStatus', 'in');
      this.dt.filter('', 'l2InternalStatus', 'in');
      this.dt.filter('', 'engagementType', 'in');
      this.dt.reset();
    }

    this.eventSearchFilterRequest = {
      pageSize: this.dataViewRecsPerPage,
      page: this.tblPageNumber,
      programTypeGuid: ProgramTypesGUID.MRPP
    };

    this.display = false;
  }
  searchOrFilterEngagements() {
    this.eventSearchFilterRequest.page = 1;
    if (this.dt) {
      this.dt.first = this.eventSearchFilterRequest.page;
    }

    if (
      this.eventSearchFilterRequest.eventKey != undefined &&
      this.eventSearchFilterRequest.eventKey.toString() === ''
    ) {
      this.eventSearchFilterRequest.eventKey = undefined;
    }

    if (
      this.eventSearchFilterRequest.partnerOrgName != undefined &&
      this.eventSearchFilterRequest.partnerOrgName.toString() === ''
    ) {
      this.eventSearchFilterRequest.partnerOrgName = undefined;
    }

    if (
      this.eventSearchFilterRequest.partnerMpnid != undefined &&
      this.eventSearchFilterRequest.partnerMpnid.toString() === ''
    ) {
      this.eventSearchFilterRequest.partnerMpnid = undefined;
    }

    if (
      this.eventSearchFilterRequest.fiscalYear != undefined &&
      this.eventSearchFilterRequest.fiscalYear.toString() === ''
    ) {
      this.eventSearchFilterRequest.fiscalYear = undefined;
    }

    this.delayedLoadSearchContent();
  }
  sort(columnKey: string) {
    const column = this.scrollableCols.find(x => x.field === columnKey);

    column.descending =
      column.descending === undefined ? true : !column.descending;

    const columnIndex = this.scrollableCols.indexOf(column);

    this.scrollableCols[columnIndex] = column;

    this.eventSearchFilterRequest.sortField = column.field;
    this.eventSearchFilterRequest.sortOrderDescending = column.descending;
    this.loadEvents();
  }
  editRequestDetails(id: number) {
    this.loadEditComponent = true;
    this.editNav = true;
    this.eventIdPassToChild = id;
    this.eventEditInput = this.eventsDisplayed.filter(
      x => x.eventRegistrationId === id
    )[0];
  }

  export() {
    this.router.navigate(['download-csv'], { relativeTo: this.route });
  }

  GetAllEventIds(): Observable<PagedResult<EventRegistrationModel>> {
    this.loading = true;
    const filter: EventSearchFilterRequest = {
      page: 1,
      pageSize: 100000,
      sortField: this.eventSearchFilterRequest.sortField,
      sortOrderDescending: this.eventSearchFilterRequest.sortOrderDescending
    };

    return this._eventDashboardServices.getAwaitingCustomerSurveyReviewEvents(
      filter
    );
  }

  showCustomerSurveyPreview(eventRegistrationId) {
    this.GetAllEventIds().subscribe(data => {
      this.allEventsDisplayed = data.results;
      this.loading = false;
      this.canShowCustomerSurveyPreviewModel = true;
      this.customerSurveyPreviewInput = {
        eventId: eventRegistrationId,
        eventIdList: this.allEventsDisplayed.map(
          event => event.eventRegistrationId
        )
      };
    });
  }

  closeCustomerSurveyPreview() {
    this.canShowCustomerSurveyPreviewModel = false;
  }

  refresh() {
    this.loadEvents();
  }

  getUploadedDate(rawData: EventRegistrationModel): string {
    if (rawData.eventRegistrationDocuments != null) {
      if (
        rawData.eventRegistrationDocuments.find(
          doc =>
            doc.eventDocumentTypeId ==
            EventDocumentTypeIds.CustomerPartnerOfRecord
        )
      ) {
        return (
          rawData.eventRegistrationDocuments.find(
            doc =>
              doc.eventDocumentTypeId ==
              EventDocumentTypeIds.CustomerPartnerOfRecord
          )?.formattedUploadDate || ''
        );
      }
    }
    return '';
  }
  onCloseEditModal() {
    this.loadEditComponent = false;
    this.editNav = false;
    this.setEventStatus();
  }
  async setEventStatus() {
    const event = await this.loadEventInfo();
    if (event) {
      const eventIndex = this.eventsDisplayed.indexOf(
        this.eventsDisplayed.find(
          event =>
            event.eventRegistrationId ===
            this.eventEditInput.eventRegistrationId
        ) as EventRegistrationModel
      );
      this.eventsDisplayed[eventIndex] = event;
    }
  }
  async loadEventInfo() {
    return await this._eventDashboardServices
      .getEventRegistration(this.eventEditInput.eventRegistrationId)
      .toPromise();
  }
  onShowFullScreenChanged(showFullscreenValue: boolean) {
    this.showFullScreen = showFullscreenValue;
    this.localStorage.setFullscreenMode(this.showFullScreen);
  }

  get currentPageInfo(): string {
    if (this.totalRecords === 0) {
      return 'No Record Found';
    } else if (this.totalRecords > 0 && this.tblPageNumber === 1) {
      return `Showing 1 - ${this.eventsDisplayed.length} of ${this.totalRecords} Records`;
    } else if (this.totalRecords > 0 && this.tblPageNumber > 1) {
      const rangeStart =
        (this.tblPageNumber - 1) * this.dataViewRecsPerPage + 1;
      let rangeEnd = 0;
      if (this.tblPageNumber * this.dataViewRecsPerPage >= this.totalRecords) {
        rangeEnd = this.totalRecords;
      } else if (
        this.tblPageNumber * this.dataViewRecsPerPage <
        this.totalRecords
      ) {
        rangeEnd = this.tblPageNumber * this.dataViewRecsPerPage;
      }
      return `Showing ${rangeStart} - ${rangeEnd} of ${this.totalRecords} Records`;
    }
    return '';
  }
}
